import gql from 'graphql-tag';

const GET_TRANSACTIONS = gql`
  query GetMerchantTransactionSummary($params: ReportInput!) {
    merchantTransactionSummary(params: $params) {
      cashbackPercentage
      numberOfTransactions
      cashbackAmount
      totalTransactionAmount
      aov
      day
      onlineNumberOfTransactions
      onlineTotalTransactionAmount
      onlineCashbackAmount
      onlineAov
      startDate
      endDate
    }
  }
`;

const GET_TRANSACTIONS_BY_SEGMENT = gql`
  query GetMerchantTransactionSummary($params: ReportInput!) {
    merchantTransactionSummaryBySegment(params: $params) {
      segmentId
      numberOfTransactions
      cashbackAmount
      totalTransactionAmount
      aov
      day
      onlineNumberOfTransactions
      onlineTotalTransactionAmount
      onlineCashbackAmount
      onlineAov
      startDate
      endDate
    }
  }
`;

export { GET_TRANSACTIONS, GET_TRANSACTIONS_BY_SEGMENT };
